module.exports = "<nav-left></nav-left>\r\n<top-module-nav class=\"top-nav\"></top-module-nav>\r\n<div class=\"fixed-right-content\" ui-view>\r\n</div>";